import { Flex, Text } from 'components'
import { LayoutType } from 'types'
import { iconByLayoutType } from '../../utils/layoutUtils'

interface Props {
  type: LayoutType
}

export default function EmptyLayout({ type }: Props) {
  const Icon = iconByLayoutType[type]

  return (
    <Flex
      alignItems="center"
      borderRadius="md"
      borderStyle="dashed"
      borderWidth="1px"
      direction="column"
      flex={1}
      gap={2}
      justify="center"
      opacity={0.8}
      p={2}
    >
      <Icon />
      <Text textAlign="center">{getText(type)}</Text>
    </Flex>
  )
}

const getText = (type: LayoutType) => {
  switch (type) {
    case 'flex':
      return 'Add layouts'
    case 'grid':
      return 'Add layouts'
    case 'tabs':
      return 'Add tabs'
    case 'carousel':
      return 'Add items'
    case 'media':
      return 'Add content'
    case 'text':
      return 'Add content'
    case 'tool':
      return 'Add tool'
    case 'trait':
      return 'Select trait'
    case 'selected-traits':
      return 'Select trait group'
  }
}
